import mitt from "mitt";
import Util from "@/helper/Utility.js";
/**
 * setting
 * @method setTitle
 * @method setMsg
 * @method setBtnOk
 * @method clearModal
 * action
 * @method show
 * @method hide
 * set event callback
 * @method onClickOk
 * event
 * @event sendCallbackOk
 */
export function FreeStarbuckModalController () {
    this.serialNumber = null;
    this.purchase = null;
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.busModal = mitt();

    this.callbackOk = null;

    //#region setter
    this.clearModal = function() {
        this.serialNumber = null;
        this.purchase = null;
        this.title = '';
        this.msg = '';
        this.btnOk = '';
        this.bgImg = '';
        this.callbackOk = null;
        return this;
    };
    this.setBgImg = function (img) {
        this.bgImg = img;
        return this;
    };
    this.setPurchase = function (purchase) {
        this.purchase = purchase;
        return this;
    };
    this.setSerial = function (serialNumber) {
        this.serialNumber = serialNumber;
        return this;
    };
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function(btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            bgImg: this.bgImg,
            purchase: this.purchase,
            serialNumber: this.serialNumber,
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
        };
        this.busModal.emit('show', config);
    };
    this.hide = function() {
        this.busModal.emit('hide');
    };
    //#endregion method

    //#region event
    this.onClickOk = function(callback) {
        if (Util.isFunction(callback)) {
            this.callbackOk = callback;
        }
    },
    this.sendCallbackOk = function(data) {
        if (Util.isFunction(this.callbackOk)) {
            this.callbackOk(data);
        }
    };
    //#endregion event
}
